import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone',
  standalone: true,
})
export class PhonePipe implements PipeTransform {
  transform(rawNum: string | undefined): string {
    if (!rawNum) {
      return '';
    }

    if (rawNum[0] !== '+' && rawNum[0] !== '8') {
      return rawNum;
    }
    let correctionIndex!: number;
    if (rawNum[0] === '+') {
      correctionIndex = 1;
    } else if (rawNum[0] === '8') {
      correctionIndex = 0;
    }

    const minLength = 11 + correctionIndex;
    if (rawNum.length < minLength) {
      return '';
    }

    return `${rawNum.slice(0, 1 + correctionIndex)} ${rawNum.slice(
      1 + correctionIndex,
      4 + correctionIndex,
    )} ${rawNum.slice(4 + correctionIndex, 7 + correctionIndex)}-${rawNum.slice(
      7 + correctionIndex,
      9 + correctionIndex,
    )}-${rawNum.slice(9 + correctionIndex)}`;
  }
}
